import React, {useMemo, useState} from 'react';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import classNames from './Leads.module.css';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import TablePagination from '@mui/material/TablePagination';
import {Link} from 'react-router-dom';
import {Layout} from '../components/common/Layout';
import {useQuery} from "@apollo/client";
import {GET_APPLICATIONS} from "../api/application/getApplications";
import {Typography} from "@mui/material";

const PER_PAGE = 10

export const statusMap = {
    'IN_PROGRESS': 'In Progress',
    'APPROVED': 'Approved',
    'REJECTED': 'Rejected',
}

export const statusColorMap = {
    'IN_PROGRESS': 'primary',
    'APPROVED': 'green',
    'REJECTED': 'red',
}

export const Applications = () => {
    const [currentPage, setCurrentPage] = useState(0)

    const options = useMemo(() => {
        return ({
            variables: {
                offset: currentPage * PER_PAGE,
                limit: PER_PAGE
            }
        })
    }, [currentPage])

    const {loading, data} = useQuery(GET_APPLICATIONS, options);

    return (
        <Layout title="Applications" isLoading={loading} showHeader showMenu>
            {data !== undefined && (
                <>
                    <TableContainer component={Paper}>
                        <Table className={classNames.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Company</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Current Stage</TableCell>
                                    <TableCell>Package Code</TableCell>
                                    <TableCell>Last Updated By</TableCell>
                                    <TableCell>Last Updated At</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.showAllApplications.applications.map((row) => (
                                    <TableRow key={row.applicationId} className={classNames.row}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.company}</TableCell>
                                        <TableCell>
                                            <Typography color={statusColorMap[row.status]}>
                                                {statusMap[row.status]}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{row.currentStage}</TableCell>
                                        <TableCell>{row.packageCode}</TableCell>
                                        <TableCell>{row.lastUpdatedBy}</TableCell>
                                        <TableCell>{row.lastUpdatedAt ? new Date(row.lastUpdatedAt).toUTCString() : ''}</TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                component={Link}
                                                to={`/applications/${row.applicationId}`}
                                                disabled={row.packageCode === null}
                                            >
                                                View
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        count={data.showAllApplications.totalCount}
                        onPageChange={(event, page) => setCurrentPage(page)}
                        page={currentPage}
                        rowsPerPage={PER_PAGE}
                        rowsPerPageOptions={[]}
                    />
                </>
            )}
        </Layout>
    )
}
